// PRODOPSAI-385 drill-down: items whose issue_type is NOT in the canonical
// type set. Sorted by per-type item count desc (worst-pervasive group first),
// then by created_date desc within each type so the freshest offenders in
// each non-canonical type bubble up. Columns come from the shared
// `buildIssueColumns` factory (Key · Type · Summary · Created · Assignee).

import type { INonCanonicalTypeItem, INonCanonicalTypesDrillResponse } from '@skystone/shared';
import { DrillTable } from './DrillTable';
import { buildIssueColumns } from './issue-columns';

const COLUMNS = buildIssueColumns<INonCanonicalTypeItem>();

interface NonCanonicalTypesTableProps {
  data: INonCanonicalTypesDrillResponse;
  loading: boolean;
  error: string | null;
  onPageChange: (page: number) => void;
}

export function NonCanonicalTypesTable({ data, loading, error, onPageChange }: Readonly<NonCanonicalTypesTableProps>) {
  return (
    <DrillTable
      columns={COLUMNS}
      rows={data.rows}
      rowKey={(row) => row.issueKey}
      pagination={data.pagination}
      onPageChange={onPageChange}
      loading={loading}
      error={error}
      emptyMessage="No non-canonical-type items in the active filter range."
    />
  );
}
